/* eslint-disable no-unused-expressions */
import React from 'react';
import './ManageControlPlanned.css';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import * as httpService from '../HttpService/HttpService';
import {getTablePageBaseOnPageNumber, getUserRole} from '../../Helpers/utils';
import SelectCustom from '../SelectCustom/SelectCustom';
import {hasPermission} from "../ControlStateHelper";
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {downloadXLSXFile} from '../documents/helpers';
import {cloneDeep} from "lodash";
import {EditControlSource} from "../../enums/editControlSource";

class ManageControlPlanned extends React.Component {

	columnsDefault = [
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Planowany termin', field: 'plannedDate', width: 80},//plannedTerm
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120},//beneficiary
		{title: 'Adres beneficjenta', field: 'project.beneficiaryAddress', width: 120},//controlPlace
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 120},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 90},//mode
		{title: 'Zespół kontrolujący', field: 'controllersDescription', minWidth: 130}
	];
	previousInputFocusId = null;

	constructor(props) {
		super(props);
		this.state = {
			columns: cloneDeep(this.columnsDefault),
			showDeleteTab: false,
			showPopup: false,
			isWaiting: false,
			tablePageSize: 10,
			page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
			programSearch: "",
			quickSearch: "",
			filter: [],
			orderBy: "number",
			orderById: "",
			orderDirection: "asc",
			filterChangeOnField: null,
			documentTitle: 'e-Kontrole | Kontrole planowane',
			hadFirstLoad: false
		};
		this.programmsPlannedSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Kontrole planowane";
		//const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters();
			newState.filter = this.props.controls.tableFilters;
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);

	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}

		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);

		if(this.state.hadFirstLoad === false && store.getState().controls.isManagePlannedControlsLoading === false) {
			fetchControlData(newState.page, ControlFunctions.getFilterParam(newState.filter), [newState.orderBy, newState.orderDirection], newState.programSearch, newState.quickSearch, newState.tablePageSize, (e) => this.handleRedirect(e));
			this.setState({hadFirstLoad: true});
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.page) {
			this.setState({
				page: 0
			});
			this.props.history.push(`/controls/planned`);
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
		}
	}

	getDefaultFilters = () => {
		const columns = cloneDeep(this.columnsDefault);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		this.setState({programSearch: values})
		this.setState({page: parseInt(0) })
		this.props.history.push(`/controls/planned`);

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], values, this.state.quickSearch, this.state.tablePageSize);
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})
	};

	deleteControl = (record) => {
		this.isWaitingOnOff(true);
		let controlId = record.id;
		let url = PropertyBucket.deleteControl(controlId);
		let callPromise = httpService.getService(url, 'DELETE', null);
		let _this = this;

		callPromise.then(
			function (message) {
				_this.props.fetchControlData(0, ControlFunctions.getFilterParam(_this.state.filter), [_this.state.orderBy, _this.state.orderDirection], _this.state.programSearch, _this.state.quickSearch, _this.state.tablePageSize);
				_this.isWaitingOnOff(false);
				_this.showPopup('Komunikat', PropertyBucket.deleteControlMessage(), 'notify')
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error.message ? error.message : error, 'error')
			}
		)
	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/controls/control_detail/' + row.id);
	};

	onEditButtonClick = (row) => {
		this.props.history.push(`/controls/edit_control/${row.id}/source/${EditControlSource.MANAGE_PLANNED}`);
	};

	onDeleteButtonClick = (row) => {
		this.showPopup('Komunikat', PropertyBucket.deleteControlConfirmationMessage(row.number), 'confirm', () => {
			this.deleteControl(row)
		})
	};

	onListPreviewButtonClick = (row) => {
		this.props.history.push('/controls/control_list_detail/' + row.id);
	};

	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.filter.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	isDisableEdit = (data) => {
		return !hasPermission(data, "control.manage.edit");
	};

	isDisableDelete = (data) => {
		return !hasPermission(data, "control.manage.delete");
	};

	handlePageChange(page, size) {
		this.setState({page: parseInt(page) })
		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, size);
	}

	handleFilterChange(filter) {
		this.state.filter.forEach((filterField, id) => {
			if (filterField.filterValue !== filter[id].filterValue) {
				this.setState({ filterChangeOnField: filter[id] });
			}
		});

		this.setState({page: parseInt(0) })
		this.setState({filter: filter })
		this.props.history.push(`/controls/planned`);
		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter, tableName: this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		this.setState({quickSearch: search, page: 0});
		this.props.history.push(`/controls/planned`);
		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, search, this.state.tablePageSize, focusOnQuickSearchInput);
	}

	handleOrderChange(column, order) {
		this.setState({page: parseInt(0) })
		this.props.history.push(`/controls/planned`);
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field :'')
		this.setState({orderById: column})
		this.setState({orderBy: orderColumn})
		this.setState({orderDirection: order})
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [orderColumn, order], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
	}

	handleListDownload() {
		const date = new Date(Date.now()).toLocaleString().split(',')[0];
		const fileName = `Zarządzaj_kontrolami_Planowane_${date}.xlsx`;
		downloadXLSXFile(fileName, 'Planowana', this.state.orderBy, this.state.orderDirection);
	}

	render() {
		let userRole = getUserRole(this.props.userData);
		let loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.managePlannedControls;
		let loadedProgsData = userRole === 'SA' ? store.getState().programs.programs : null;
		let table;
		let dropdown;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
							title={this.state.popUp.title}
							notification={this.state.popUp.notification}
							link={this.state.popUp.link}
							onClickEvent={this.state.popUp.onClickEvent}
							closePopUp={this.handleClosePopUp}
			/>) : null;

		if (this.props.controls && this.props.controls.isManagePlannedControlsLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);

				table = <TableCustomLazyLoading
					isActionsMultilines
					columns={this.state.columns}
					data={loadedControlsData}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={totalElements}
					page={this.state.page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1', margin: 0, padding: 0 } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'editButton',
							iconProps: {
								style: {
									fontSize: '24px',
									color: this.isDisableEdit(rowData) ? '#ccc' : '#0d47a1'
								}
							},
							tooltip: <span>Edytuj<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onEditButtonClick(rowData);
							},
							disabled: this.isDisableEdit(rowData),
						}),

						rowData => ({
							icon: 'delete',
							iconProps: {
								style: {
									fontSize: '24px',
									color: this.isDisableDelete(rowData) ? '#ccc' : '#0d47a1'
								}
							},
							tooltip: <span>Usuń <span
								className='sr-only'> kontrolę: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDeleteButtonClick(rowData);
							},
							disabled: this.isDisableDelete(rowData)
						}),
						rowData => ({
							icon: 'find_in_page',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Podgląd listy<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onListPreviewButtonClick(rowData);
							}
						}),
					]}
					initialPage={getTablePageBaseOnPageNumber(
						this.props.match.params.pageNumber,
						this.state.tablePageSize,
						this.props.lists.lists.length)}
					pageSize={this.state.tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/controls/planned/${parseInt(page) + 1}`)
							this.setState({page: parseInt(page)})
							this.setState({tablePageSize: parseInt(size)})
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onQuickSearchChange={(value) => {
						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.quickSearch}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsPlannedSelectId'
					dropdownId='programmsPlannedDropdownId'
					label='Programy'
					parentRef={this.programmsPlannedSelectRef}
				/>
			</div>
		}

		return (
			<div id='control_search'>
				{popUp}
				<div id='add_control'>
					<h2 className='mb-4 float-left'>Kontrole - Planowane</h2>
					<Link to='/create_control' className='btn save-btn' id='plus_img_container'><i data-v-db6946bc=''
					                                                                               aria-hidden='true'
					                                                                               className='v-icon material-icons theme--light v-list-text'>add</i><span>UTWÓRZ KONTROLĘ</span></Link>
					<div className='clearfix'/>
				</div>
				<div>
					{userRole === 'SA' ? dropdown : null}
					<div id='controls_table'>
						<div style={{display: 'flex', flexDirection: 'column'}}>
							<button type='button' onClick={() => this.handleListDownload()} className='btn save-btn download-xlsx-btn'>
								<i data-v-db6946bc='' aria-hidden='true' className='v-icon material-icons theme--light v-list-text'>download</i><span>POBIERZ</span>
							</button>
							{table}
						</div>
					</div>
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isManagePlannedControlsLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};


const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getControlsPlanned();
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}
	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, undefined, successCallback, 'managePlanned')),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
	}
};
export const ManageControlPlannedProvider = connect(mapStateToProps, mapDispatchToProps)(ManageControlPlanned);
